export default __webpack_public_path__ + "static/media/533.ce37d56b.jpg";